import { defineMessages } from 'react-intl';

export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'search-respository-result.label',
		defaultMessage: 'Repository',
		description: 'Badge label shown on a repository search result to indicate the result type.',
	},
});
